/* function GaEvent */
export const gaEvent = (gtagTracking: boolean, category: any, action: any, label: any, value: any, appContext: string) => {
    if (appContext === 'production' && gtagTracking) {
        if (category === "sendpurchase") {
            (window as any).dataLayer.push({
                'transactionId': label.transaction_id,
                'transactionTotal': label.value,
                'event': 'orderComplete'
             });
            (window as any).gtag("event", "purchase", label);
            // Eki's hack to add facebook event here too
            if ((window as any).fbq){
                (window as any).fbq("track", "Purchase", {
                    'content_ids': label.transaction_id,
                    'content_type': 'product',
                    'value': label.value,
                    'currency': 'EUR'
                });
            }
        } else {
            (window as any).gtag('event', action, {
                'screen_name': label
            });
        }
    } else {
        if (!gtagTracking) {
            console.log('NOTE: gtag tracking off. Action = '+ action+', label = '+JSON.stringify(label));
        }
        console.log('\x1b[33mGA4 Analytics data was not sent. Action = '+ action+', label = '+JSON.stringify(label) + '\x1b[0m');
    }
}
